import React from 'react'

export const NoImageIcon = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="#F2F4F5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="4" fill="#F2F4F5" />
      <path
        d="M52.9312 47.3125C52.9622 47.5395 53.0002 47.7645 53.0002 48.0005C53.0002 50.7615 50.7612 53.0005 48.0002 53.0005C47.7642 53.0005 47.5392 52.9625 47.3122 52.9315L44.2422 56.0005H58.0002C58.5532 56.0005 59.0002 55.5525 59.0002 55.0005V42.0005C59.0002 41.7875 58.9182 41.6005 58.8052 41.4385L52.9312 47.3125Z"
        fill="#979899"
      />
      <path
        d="M38 56H40L44.464 51.536C43.56 50.631 43 49.381 43 48C43 45.239 45.239 43 48 43C49.381 43 50.631 43.56 51.536 44.464L55 41H53.535L51.832 38.445C51.646 38.167 51.334 38 51 38H45C44.666 38 44.354 38.167 44.168 38.445L42.465 41H38C37.447 41 37 41.448 37 42V55C37 55.552 37.447 56 38 56Z"
        fill="#979899"
      />
      <path
        d="M37.0002 60.0002C36.7442 60.0002 36.4882 59.9023 36.2932 59.7073C35.9022 59.3162 35.9022 58.6842 36.2932 58.2932L58.2932 36.2932C58.6842 35.9022 59.3162 35.9022 59.7073 36.2932C60.0983 36.6842 60.0983 37.3162 59.7073 37.7072L37.7072 59.7073C37.5122 59.9023 37.2563 60.0002 37.0002 60.0002Z"
        fill="#979899"
      />
    </svg>
  )
}
